import { ScreenProps } from '@components-common/types';
import { ConfigElement } from '@components-fabric/types';
import { mapToolbar } from './toolbar';
import { mapForm } from './form';
import { mapView } from './view';

export const mapEditScreen = (config: ConfigElement, context: ScreenProps) => {
  context.type = 'edit';
  const result = {
    type: 'edit',
    view: {
      ...mapView(config, context),
      ...{
        props: {
          toolbar: mapToolbar(config, context),
          form: mapForm(config as any, context),
        },
      },
    },
  };
  return result;
};
